/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type EvmErc721TransferLogInfo = {
    EVT: EvmErc721TransferLogInfo.EVT;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    TKNSINFO: EvmTokenSummaryInfo;
    TKNID: string;
    TKNVAL: string;
    TKNNAME?: string;
    IMGURL?: string;
};

export namespace EvmErc721TransferLogInfo {

    export enum EVT {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
    }


}

